export default __webpack_public_path__ + "static/media/p4-8.3b4d3a9e.png";